// extracted by mini-css-extract-plugin
module.exports = {"Root":"CreateBufferDialog_Root__3EzN3"};